import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { getSafeId } from '@mantine/utils';
import { useId, useUncontrolled } from '@mantine/hooks';
import { TabsContextProvider } from './Tabs.context.js';
import { TABS_ERRORS } from './Tabs.errors.js';

function TabsProvider(_ref) {
  var defaultValue = _ref.defaultValue,
      value = _ref.value,
      onTabChange = _ref.onTabChange,
      orientation = _ref.orientation,
      children = _ref.children,
      loop = _ref.loop,
      id = _ref.id,
      activateTabWithKeyboard = _ref.activateTabWithKeyboard,
      allowTabDeactivation = _ref.allowTabDeactivation,
      variant = _ref.variant,
      color = _ref.color,
      radius = _ref.radius,
      inverted = _ref.inverted,
      placement = _ref.placement,
      _ref$keepMounted = _ref.keepMounted,
      keepMounted = _ref$keepMounted === void 0 ? true : _ref$keepMounted,
      classNames = _ref.classNames,
      styles = _ref.styles,
      unstyled = _ref.unstyled;
  var uid = useId(id);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      mountedPanelIds = _useState2[0],
      setMountedPanelIds = _useState2[1];

  var _useUncontrolled = useUncontrolled({
    value: value,
    defaultValue: defaultValue,
    finalValue: null,
    onChange: onTabChange
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      _value = _useUncontrolled2[0],
      onChange = _useUncontrolled2[1];

  return (
    /* @__PURE__ */
    React.createElement(TabsContextProvider, {
      value: {
        placement: placement,
        value: _value,
        orientation: orientation,
        id: uid,
        loop: loop,
        activateTabWithKeyboard: activateTabWithKeyboard,
        getTabId: getSafeId("".concat(uid, "-tab"), TABS_ERRORS.value),
        getPanelId: getSafeId("".concat(uid, "-panel"), TABS_ERRORS.value),
        onTabChange: onChange,
        setMountedPanelIds: setMountedPanelIds,
        mountedPanelIds: mountedPanelIds,
        allowTabDeactivation: allowTabDeactivation,
        variant: variant,
        color: color,
        radius: radius,
        inverted: inverted,
        keepMounted: keepMounted,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
      }
    }, children)
  );
}

TabsProvider.displayName = "@mantine/core/TabsProvider";
export { TabsProvider };